<div
  #dialogEl
  class="dialog-overlay"
  role="dialog"
  [class.in]="isInClassActive()"
  [class.out]="isOutClassActive()"
  [style.z-index]="zIndex()"
  [attr.inert]="isVisible() ? null : ''"
  [id]="id"
  [attr.aria-labelledby]="id + '_title'"
  [attr.aria-describedby]="id + '_description'"
>
  <div class="dialog-backdrop"></div>
  <div class="dialog-content">
    <section opacFocusTrap>
      <header #headerEl>
        <ng-content select="[slot='header']"></ng-content>

        <ng-container *ngIf="!customHeader()">
          <h3 [id]="id + '_title'">{{ title }}</h3>

          <opac-button (click)="closed.emit()" [ariaLabel]="'general.close' | translate" [opacTooltip]="'general.close' | translate">
            <opac-icon slot="only-icon" icon="close"></opac-icon>
          </opac-button>
        </ng-container>
      </header>

      <div class="content" [id]="id + '_description'">
        <ng-content></ng-content>
      </div>

      <footer>
        <ng-content select="[slot='actions']"></ng-content>
      </footer>
    </section>
  </div>
</div>
